module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noUserActivity":"User activity has not been recorded in the last two years."},"ja":{"noUserActivity":"過去2年間にユーザ行動が記録されていません"},"zh-hant":{"noUserActivity":"最近兩年未記錄任何用戶活動"},"zh-hans":{"noUserActivity":"最近两年未记录任何用户活动"}}')
  delete Component.options._Ctor
}
